var f = require("./game-overlay.js");
var UI = module.exports;
UI.active = true;
UI.menu2 = "rcY";
var h = true;
UI.isMobile = false;
UI.hasEndScreen = false;
UI.previewType = 0;
UI.loading = false;
UI.toggleMenu = function (j) {
  menuHolder.style.display = j ? "block" : "none";
  speakerDisplay.style.display = j ? "none" : "block";
  chatHolder.style.bottom = (j ? 20 : 148) + "px";
  voiceDisplay.style.bottom = (j ? 18 : 145) + "px";
  supportMapCreator.style.display = "none";
  UI.toggleMenuHider(j);
  if (j) {
    endUI.style.display = "none";
    instructionHolder.style.display = "block";
    if (windowHolder.style.display != "block") {
      baseLinks.style.display = "block";
    }
    if (newLeaderDisplay.style.display != "none") {
      newLeaderDisplay.style.display = "none";
    }
    if (terminalHolder.style.display != "none") {
      terminalHolder.style.display = "none";
    }
  }
  UI.active = true;
  UI.previewType = 0;
  menuClassContainer.style.visibility = "";
};
UI.hideUI = function (j) {
  if (!j) {
    UI.toggleMenu(false);
  }
  inGameUI.style.display = "none";
  overlay.style.display = "none";
  vignette.style.display = "none";
  spectateUI.style.display = "none";
  aimRecticle.style.display = "none";
  if (!j) {
    instructionHolder.style.display = "none";
  }
  baseLinks.style.display = "none";
  chatHolder.style.bottom = "20px";
  voiceDisplay.style.bottom = "18px";
  speakerDisplay.style.right = "20px";
  purchaseHolder.style.display = "none";
  consentBlock.style.display = "none";
  bdayBlock.style.display = "none";
  UI.active = false;
};
UI.hideDiscon = function () {
  chatHolder.style.display = "none";
  voiceDisplay.style.display = "none";
  speakerDisplay.style.display = "none";
  purchaseHolder.style.display = "none";
};
UI.showEndScreen = function (j) {
  UI.hasEndScreen = true;
  endMidHolder.style.display = "none";
  matchVoteHolder.style.display = "none";
  teamTotal0.style.display = "none";
  teamTotal1.style.display = "none";
  if (!j) {
    endInfo.style.display = "none";
  }
  endUI.style.display = j ? "none" : null;
  UI.hideUI(j);
};
UI.toggleWindow = function (j) {
  UI.previewType = 0;
  menuClassContainer.style.visibility = "";
  supportMapCreator.style.display = "none";
  windowHolder.style.display = j ? "block" : "none";
  baseLinks.style.display = j ? "none" : "block";
  UI.updatePlayInstructions();
  if (!j) {
    window.closeWindow();
  }
};
UI.toggleMenuHider = function (j) {
  menuHider.style.display = j ? "block" : "none";
  uiBase.classList.toggle("onMenu", j);
  gameNameHolder.style.display = j ? null : "none";
  spectButton.style.display = h && j ? null : "none";
  supportMapCreator.style.display = "none";
  if (j) {
    spinUI.style.display = "none";
    respinUI.style.display = "none";
  }
  if (!j) {
    clearPops();
  }
};
UI.toggleEndScreen = function () {
  if (UI.hasEndScreen && endInfo.style.display == "block") {
    if (endUI.style.display == "none") {
      endUI.style.display = null;
      endInfo.style.display = "block";
      victorySub.style.display = "";
      menuHolder.style.display = "none";
      UI.hideUI();
    } else {
      UI.toggleMenu(true);
    }
  }
};
UI.setShowSpect = function (j) {
  h = j;
  spectButton.style.display = j ? null : "none";
};
UI.setShowSelTeam = function (j) {
  teamSelector.style.display = j ? "block" : "none";
};
UI.showError = function (j) {
  UI.toggleMenu(true);
  instructions.innerHTML = j;
};
UI.toggleGameUI = function (j) {
  var k = j && !window.spectating;
  spectateUI.style.display = window.spectating && j ? "block" : "none";
  if (window.spectating) {
    propInstruct.style.display = "none";
  }
  mobileUI.style.display = j && UI.isMobile ? "block" : "none";
  gameMessage.style.display = k ? "block" : "none";
  topLeftHolder.style.display = k ? "block" : "none";
  topRight.style.display = j ? "block" : "none";
  reloadMsg.style.display = k ? "block" : "none";
  bottomLeftHolder.style.display = k ? "block" : "none";
  weapDisplay.style.display = k ? "block" : "none";
  bottomRight.style.display = k ? "block" : "none";
  killCardHolder.style.display = j ? "none" : "block";
  speakerDisplay.style.right = (j ? 380 : 20) + "px";
  chatHolder.style.bottom = (k ? 148 : 20) + "px";
  voiceDisplay.style.bottom = (k ? 145 : 18) + "px";
  overlay.style.display = k ? "block" : "none";
  vignette.style.display = k ? "block" : "none";
  igXPBar.style.display = k ? "block" : "none";
  interactProg.style.display = "none";
  interactMsg.style.display = "none";
  uiBase.classList.toggle("onGame", j);
};
UI.toggleControlUI = function (j) {
  if (UI.loading) {
    j = false;
  }
  spectateUI.style.display =
    window.spectating && j && !UI.hideGameUI ? "block" : "none";
  inGameUI.style.display = j && UI.active && !UI.hideGameUI ? "block" : "none";
  mobileUI.style.display = j && UI.active && UI.isMobile ? "block" : "none";
  overlay.style.display = j && UI.active && !UI.hideGameUI ? "block" : "none";
  vignette.style.display = j && UI.active && !UI.hideGameUI ? "block" : "none";
  aimRecticle.style.display = j && UI.active ? "block" : "none";
  instructionHolder.style.display = !j && UI.active ? "block" : "none";
  newLeaderDisplay.style.display = "none";
  terminalHolder.style.display = "none";
  aHolder.style.display = j ? "none" : "block";
  toggleAd(!j);
  infoHolder.style.display = j ? "none" : null;
  chatHolder.style.bottom =
    (j && !window.spectating && bottomLeftHolder.style.display == "block"
      ? 148
      : 20) + "px";
  voiceDisplay.style.bottom =
    (j && !window.spectating && bottomLeftHolder.style.display == "block"
      ? 145
      : 18) + "px";
  speakerDisplay.style.display = j && UI.active ? "block" : "none";
  if (endUI.style.display) {
    menuHolder.style.display = j ? "none" : "block";
    UI.toggleMenuHider(!j);
  }
  clearPops();
};
UI.updateCrosshair = function (j, k) {
  f.crosshairOpacity = k;
  f.crosshairScale = j;
};
